import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  ManageSmartPayRootParamList,
  SettingsRootParamList,
} from "../../../../types";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { ManageSmartPayScreen } from "./ManageSmartPayScreen";
import { SmartPayPairingScreen } from "./SmartPayPairingScreen";
import React from "react";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import { Q } from "@nozbe/watermelondb";
import PaymentMethod from "../../../../utilities/data/model/PaymentMethod";
import { ScreenContext } from "./context";

const Stack = createStackHeaderNavigator<ManageSmartPayRootParamList>();

export interface ManageSmartPayRootScreenProps
  extends StackScreenProps<SettingsRootParamList, "ManageSmartPayRootScreen"> {}

export const ManageSmartPayRootScreen = ({
  route,
  navigation,
}: ManageSmartPayRootScreenProps) => {
  const database = useDatabase();

  const [paymentMethod, setPaymentMethod] = React.useState<
    PaymentMethod | undefined
  >();
  const { paymentMethodId } = route.params;
  React.useEffect(() => {
    database
      .get<PaymentMethod>("payment_methods")
      .query(
        Q.where("id", Q.eq(paymentMethodId)),
        Q.where("deleted_at", Q.eq(null))
      )
      .fetch()
      .then((p) => setPaymentMethod(p[0]))
      .catch((e) => console.log(e));
  }, []);

  if (!paymentMethod) {
    return null; // or a loading indicator
  }

  return (
    <ScreenContext.Provider value={{ paymentMethod }}>
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <Stack.Group
          screenOptions={{
            title: "",
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        >
          <Stack.Screen
            name="ManageSmartPayScreen"
            component={ManageSmartPayScreen}
          />
          <Stack.Screen
            name="SmartPayPairingScreen"
            component={SmartPayPairingScreen}
            options={{
              headerLeft: () => <ModalCloseButton type="Cancel" />,
            }}
          />
        </Stack.Group>
      </Stack.Navigator>
    </ScreenContext.Provider>
  );
};
